import { translate } from '../../../i18n';
import { GameAdminCommentCategory } from '../../../models/game/dto/game-admin-comment.dto';

export const categoryColors: Record<GameAdminCommentCategory, string> = {
    [GameAdminCommentCategory.PAYMENT_EXTERNAL]: 'orange',
    [GameAdminCommentCategory.GENERAL]: 'blue',
    [GameAdminCommentCategory.ISSUE]: 'red',
    [GameAdminCommentCategory.REFUND]: 'purple',
};

export const categoryLabels: Record<GameAdminCommentCategory, string> = {
    [GameAdminCommentCategory.PAYMENT_EXTERNAL]: translate('admin_comments.payment_category.payment_external'),
    [GameAdminCommentCategory.GENERAL]: translate('admin_comments.payment_category.general'),
    [GameAdminCommentCategory.ISSUE]: translate('admin_comments.payment_category.issue'),
    [GameAdminCommentCategory.REFUND]: translate('admin_comments.payment_category.refund'),
};
